module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/icon_number_11-159acbaeca5dba419404da2223fa99d3.svg";